module.exports = __webpack_public_path__ + "static/media/LP8.b51f233a.svg";